import React from 'react'
import PropTypes from 'prop-types';
import Map from './kraje.svg';
import { cx } from 'react-emotion';
import styles, { regionalMap } from './styles';
import UpdateBlocker from '../UpdateBlocker';
import colors from '../../colors';
import { getHasElectionFinished } from '../../Utils/Getters';

export default class MapRegional extends React.Component {
	ref = React.createRef();

	componentDidMount() {
		this.ref.current.addEventListener('click', this.onClick);
		this.setup();
	}

	componentDidUpdate() {
		this.setup();
	}


	setup() {
		this.props.regions.forEach(region =>{
			const svgPath = this.getPathElementById(region.id);
			if (svgPath) {
				this.setActive(region, svgPath)
				this.setSelected(region, svgPath)
				this.setTooltip(region, svgPath)
				svgPath.setAttribute('data-id', region.id);

			}
		})
		if (this.props.regions.length && getHasElectionFinished(this.props.meta)) {
			this.colorize();
		}
	}

	setTooltip(region, svgPath) {
		const winnerParty = this.getWinnerParty(region);
		const winnerDetails = winnerParty ? `\n${winnerParty.name}\nPočet mandátů: ${winnerParty.mandates.count}` : ''
		svgPath.querySelector('title').textContent = `${region.name} kraj${winnerDetails}`;
	}



	setSelected(region, svgPath) {
		const selectedRegionId = this.props.selectedRegionId;
		const regionId = region.id;
		if (String(regionId) === selectedRegionId) {
			svgPath.classList.add('selected');
		} else {
			svgPath.classList.remove('selected');
		}
	}

	setActive(region, svgPath) {
		const active = this.props.regions.length;
		svgPath.classList.add(active ? 'active' : '');
	}


	onClick = (event) => {
		if (event.target.nodeType !== Node.ELEMENT_NODE || event.target.tagName !== 'path') {
			return;
		}
		const id = event.target.getAttribute('data-id');
		id && this.props.onClick(id);
	}


	getPathElementById = (id) => {
		const elements = this.ref.current.getElementsByClassName('id-' + id);
		return elements.length > 0 ? elements[0] : null;
	};

	getWinnerParty = (region) => {
		if (getHasElectionFinished(this.props.meta)) {
			const sortedParties = region.parties.sort((p1, p2) => {
				return p1.votes > p2.votes ? -1 : 1;
			});
			return sortedParties[0];
		}
	};

	getColorByParty = (party) => {
		return colors[party.id];
	};

	getWinnerPartyColors = (regions) => {
		const winnerParties = {};
		regions.map(region => {
			const winnerParty = this.getWinnerParty(region);
			const partyColor = this.getColorByParty(winnerParty);
			winnerParties[region.id] = partyColor;
		});
		return winnerParties;
	};

	colorize() {
		const { regions } = this.props;
		const winnerPartyColors = this.getWinnerPartyColors(regions);
		regions.map(region => {
			const svgPath = this.getPathElementById(region.id);
			if (svgPath) {
				svgPath.style.fill = winnerPartyColors[region.id] || colors.default;
			}
		});
	}

	render() {
		return (
			<div ref={this.ref}>
				<UpdateBlocker>
					<Map className={cx(styles, regionalMap)} />
				</UpdateBlocker>
			</div>
		)
	}
}

MapRegional.propTypes = {
	regions: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired
	})),
	onClick: PropTypes.func,
	meta: PropTypes.shape({ count: PropTypes.number, isFinal: PropTypes.bool, turnout: PropTypes.number }),
	selectedRegionId: PropTypes.string
}

MapRegional.defaultProps = {
	onClick: (id) => {
		window.location.hash = `/kraj/${id}`
	}
}
